import { render, staticRenderFns } from "./ParticipantHeader.vue?vue&type=template&id=b6de1d44&scoped=true&"
import script from "./ParticipantHeader.vue?vue&type=script&lang=js&"
export * from "./ParticipantHeader.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantHeader.vue?vue&type=style&index=0&id=b6de1d44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6de1d44",
  null
  
)

export default component.exports